export function getActiveValue(active: Array<{ label: string; value: any }>) {
  const yesItem = active.find((item) => item.label?.toLowerCase() === 'yes');
  const noItem = active.find((item) => item.label?.toLowerCase() === 'no');
  return { yes: yesItem?.value ?? 1, no: noItem?.value ?? 0 };
}
export const isActiveEqual = (v: any, activeYes: any): boolean => v === activeYes;
